module.exports = __webpack_public_path__ + "img/92.ba552483.ba552483.png";